// @vue/component

import { DAYS_OBJECT } from "@/utils/consts";
import moment from "moment";
const splitTime = time => time.split(":");
const today = new Date();

const year = today.getFullYear();
const month = today.getMonth();
const day = today.getDate();

export default {
  name: "RecordActionButtons",

  components: {},

  props: {
    recordDetails: {
      type: Object,
      default: () => ({})
    },
    isCurrentCall: {
      type: Boolean,
      default: false
    },
    campaignUuid: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      form: {
        isCopyNote: false,
        isDateChange: false,
        date: "",
        days: this.recordDetails.workday.split("").map(el => Number(el)),
        time: [
          new Date(
            year,
            month,
            day,
            splitTime(this.recordDetails.time_start)[0],
            splitTime(this.recordDetails.time_start)[1]
          ),
          new Date(
            year,
            month,
            day,
            splitTime(this.recordDetails.time_stop)[0],
            splitTime(this.recordDetails.time_stop)[1]
          )
        ],
        isWorkDaysAndTimes: false
      },
      isClonePopoverVisible: false,
      isNoteEditVisible: false,
      isDeletePopoverVisible: false,
      callNote: ""
    };
  },
  computed: {
    currentCallingAgentUuid() {
      return this.$store.getters["user/agent/callingAgentDetails"]?.details?.uuid;
    },
    canDeleteRecords() {
      return this.$store.getters["authorization/acl"].hasPermission(
        "allow_remove_campaign_records"
      );
    },
    daysOptions() {
      return DAYS_OBJECT;
    }
  },
  watch: {
    recordDetails: {
      handler() {
        this.callNote = this.recordDetails.note;
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async cloneRecord() {
      const params = {
        dialout_records_uuid: this.recordDetails.uuid,
        note: this.recordDetails.note,
        project_uuid: this.recordDetails.project_uuid,
        dialout_num_uuid: this.recordDetails.dialout_num_uuid,
        dialout_dictionary_uuid: this.recordDetails.dialout_dictionary_uuid,
        workday: this.recordDetails.workday,
        time_start: this.recordDetails.time_start,
        time_stop: this.recordDetails.time_stop,
        pause_time_min: this.recordDetails.pause_time_min,
        count_try: this.recordDetails.count_try,
        num_for_call: this.recordDetails.num_for_call,
        adescom_num: this.recordDetails.adescom_num,
        stamp: this.recordDetails.stamp,
        active: this.recordDetails.active,
        sleep_time: this.recordDetails.sleep_time
      };
      if (this.form.isDateChange) params.stamp = this.form.date;
      if (this.form.isWorkDaysAndTimes) {
        const timesEdited = this.form.time.map(el => moment(el).format("HH:mm:ss"));
        params.workday = this.form.days.sort().join("");
        params.time_start = timesEdited[0];
        params.time_stop = timesEdited[1];
      }
      if (!this.form.isCopyNote) delete params.note;
      const responseStatus = await this.$store.dispatch("campaign/cloneRecord", params);
      if (responseStatus === 200) {
        this.$message({
          type: "success",
          message: "Stworzono kopię rekordu."
        });
      } else {
        this.$message({
          type: "error",
          message: "Wystąpił błąd podczas kopiowania rekordu"
        });
      }
      this.isClonePopoverVisible = false;
    },
    async editNoteForCall() {
      const responseStatus = await this.$store.dispatch("campaign/editNoteForCall", {
        note: this.callNote,
        record_uuid: this.recordDetails.uuid
      });
      if (responseStatus === 200) {
        this.$message({
          type: "success",
          message: "Dodano nową notatkę."
        });
        if (this.isCurrentCall) {
          await this.$store.dispatch(
            "campaign/getCurrentCallDetails",
            this.currentCallingAgentUuid
          );
        } else {
          await this.$store.dispatch("campaign/getDetails", this.campaignUuid);
        }
      } else {
        this.$message({
          type: "error",
          message: "Wystąpił błąd podczas edycji notatki"
        });
      }
      this.isNoteEditVisible = false;
    },
    async deleteRecord() {
      await this.$store.dispatch("campaign/removeRecord", { record_uuid: this.recordDetails.uuid }); //<= usuwanie
      await this.$store.dispatch("campaign/getDetails", this.campaignUuid);
    }
  }
};
